module.exports = __webpack_public_path__ + "img/hair_front_female_left_part.11d5fcc7.png";